import React from 'react';
import { useCart } from '../context/CartContext';

export default function CartToast() {
  const { toastMessage, setToastMessage, openCart } = useCart();

  if (!toastMessage) return null;

  return (
    <div className="fixed bottom-6 left-6 z-40 max-w-sm w-full animate-in fade-in slide-in-from-bottom-4 duration-200">
      <div className="bg-[#39463A] text-white p-4 rounded-2xl shadow-2xl border border-[#71806A]/40 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <div className="w-9 h-9 rounded-xl bg-[#71806A]/40 text-[#BCC6B2] flex items-center justify-center shrink-0">
            <i className="fa-solid fa-check text-sm" aria-hidden="true" />
          </div>
          <div className="min-w-0">
            <p className="text-[11px] font-bold uppercase tracking-wider text-[#BCC6B2]">
              {toastMessage.title}
            </p>
            <p className="text-xs font-bold text-white truncate">
              {toastMessage.name}
            </p>
            <p className="text-[10px] text-[#DED3C0]">
              {toastMessage.quantity} stk. ({toastMessage.variant})
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2 shrink-0">
          <button
            type="button"
            onClick={() => {
              setToastMessage(null);
              openCart();
            }}
            className="px-3 py-1.5 rounded-lg bg-[#71806A] hover:bg-[#5C6A56] text-white text-[11px] font-bold uppercase tracking-wider transition-colors cursor-pointer"
          >
            Se kurv
          </button>
          <button
            type="button"
            onClick={() => setToastMessage(null)}
            className="w-7 h-7 rounded-lg text-[#DED3C0] hover:text-white flex items-center justify-center transition-colors cursor-pointer"
            aria-label="Luk besked"
          >
            <i className="fa-solid fa-xmark text-xs" />
          </button>
        </div>
      </div>
    </div>
  );
}
